window.site = (window.site || {});

/**
 * Init Mobile Menu related scripts
 * @class Site
 * @static
 */
site.MenuMobile = (function MenuMobile() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $trigger = document.querySelector('.mobile-menu-trigger');
    const $triggerClose = document.querySelector('.navigation-close');

    if ($trigger) {
      $trigger.addEventListener('click', (e) => {
        const $main = document.querySelector('.site-container');
        const $menu = document.querySelector('.navigation-mobile');
  
        $main.classList.toggle('active');
        $menu.classList.toggle('is-active');
      });
    }


    if ($triggerClose) {
      $triggerClose.addEventListener('click', (e) => {
        const $main = document.querySelector('.site-container');
        const $menu = document.querySelector('.navigation-mobile');
  
        $main.classList.toggle('active');
        $menu.classList.toggle('is-active');
      });
    }


    const $exception = document.querySelector('.navigation-link a.scroll');

    if ($exception) {
      $exception.addEventListener('click', (e) => {
        const $main = document.querySelector('.site-container');
        const $menu = document.querySelector('.navigation-mobile');
  
        $main.classList.remove('active');
        $menu.classList.remove('is-active');
  
        return true;
      });
    }


    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}());
